module.exports = __webpack_public_path__ + "static/media/hand.1453f9e7.svg";